import { AppState } from '@/store';
import ColorSwatchStyles from '@components/ColorSwatchStyles';
import { TColorSwatch } from '@types';
import React, { memo, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

const PartnerColorSwatchStyles = () => {
  const {
    sidebarFilters: { colors },
    filterOptions: { colors: colorsSelected },
    refData: { colors: refColors },
  } = useSelector((state: AppState) => state.partner);
  const [filteredColors, setFilteredColors] = useState<TColorSwatch[]>([]);

  useEffect(() => {
    if (colorsSelected.length > 0)
      refColors?.length > 0 &&
        setFilteredColors(refColors.filter((i) => colorsSelected.indexOf(i.id as never) >= 0));
    else if (filteredColors.length !== 0) setFilteredColors([]);
  }, [colors, colorsSelected, refColors]);

  return <ColorSwatchStyles colors={[...new Set(colors.concat(filteredColors))]} />;
};

export default memo(PartnerColorSwatchStyles);
